import {create} from 'zustand';

const authMsgStore = create((set,get) =>({
    authMsg: "",
    setAuthMsg: (newMsg) => set(state => ({...state, authMsg: newMsg })),
    clearAuthMsg: () => set(state => ({...state, authMsg: "" })),
}))

export default authMsgStore